export class Drf {
    tipoDocRelacionado: string;
    numeroDocRelacionado: string;

    constructor(tipoDocRelacionado?: string,
                numeroDocRelacionado?: string
    ) {
        this.tipoDocRelacionado = tipoDocRelacionado;
        this.numeroDocRelacionado = numeroDocRelacionado;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/drf.ts